import { setup } from 'meta-pixel';

const PIXEL_ID = '4033647100269664';

type PixelController = ReturnType<typeof setup>;

let controller: PixelController | null = null;

/**
 * Initializes the Meta Pixel once and fires the initial PageView.
 * Safe to call multiple times (e.g. across component mounts) — it only sets up once.
 */
export function initMetaPixel() {
  if (controller || typeof window === 'undefined') return;
  controller = setup().init(PIXEL_ID).pageView();
}

/**
 * Tracks a standard or custom Meta Pixel event. No-op until the pixel has been initialized.
 */
export function trackMetaEvent(event: string, params?: Record<string, unknown>) {
  if (!controller) return;
  controller.$fbq('track', event as never, params as never);
}
